export const getMaxPlayerHealth = (player) => player.cards.includes("big_heart") ? 12 : 10;
export const getExtraDiceCount = (player) => player.cards.filter((cardId) => cardId === "helping_cube").length;
export const isPlayerBusinessMan = (player) => player.cards.includes("the_businessman");
